import {Grid, Hide} from 'platform/foundation';

import {OfferPriceResponseBody, OfferSaleVehicleResponseBody} from '@dms/api/finance';
import {BusinessCaseResponseBody, SaleBusinessCasePricesOverviewResponseBody} from '@dms/api/sales';
import {SaleVehicleResponseBody} from '@dms/api/vehicle';
import i18n from '@dms/i18n';
import {usePricePermissions} from '@dms/shared';
import {PriceBox} from '@dms/teas';

import {suffixTestId, TestIdProps} from 'shared/web';

interface BusinessCaseSaleVehicleShortPricesProps extends TestIdProps {
  saleVehicleData?: SaleVehicleResponseBody;
  saleVehiclePrices?: SaleBusinessCasePricesOverviewResponseBody;
  businessCaseData?: BusinessCaseResponseBody;
  saleVehicle: OfferSaleVehicleResponseBody;
  offerTotalPrice?: OfferPriceResponseBody | null;
  permissions: ReturnType<typeof usePricePermissions>;
  isBrokeredSale: string | null;
  businessCaseLogic: {
    isBrokerage: boolean;
    isOpenBusinessCase: boolean;
    totalMarginPercentage: number;
    isTotalVatDeductible: boolean;
    shouldShowBrokerageContent: boolean;
  };
}

export function BusinessCaseSaleVehicleShortPrices(props: BusinessCaseSaleVehicleShortPricesProps) {
  return (
    <Grid columns={4}>
      <Hide when={props.isBrokeredSale}>
        <PriceBox
          data-testid={suffixTestId(`buyingPrice`, props)}
          align="left"
          price={props.saleVehicleData?.purchasePrice?.withVat}
          priceSub={props.saleVehicleData?.purchasePrice?.withoutVat}
          isVatDeductible={props.saleVehicleData?.isVatDeductible}
          title={i18n.t`entity.businessCase.labels.vehicleBuyingPrice`}
        />
      </Hide>
      <PriceBox
        data-testid={suffixTestId(`sellingPrice`, props)}
        align="left"
        price={props.saleVehicle?.sellingPrice?.withVat}
        priceSub={props.saleVehicle?.sellingPrice?.withoutVat}
        isVatDeductible={props.saleVehicle?.sellingPrice?.vatCode !== 'Z'}
        title={i18n.t`entity.businessCase.labels.vehicleSellingPrice`}
      />
      <PriceBox
        data-testid={suffixTestId(`totalPrice`, props)}
        align="left"
        price={props.offerTotalPrice?.withVat}
        priceSub={props.offerTotalPrice?.withoutVat}
        isVatDeductible={props.businessCaseLogic.isTotalVatDeductible}
        title={i18n.t`entity.businessCase.labels.totalPrice`}
      />
      <Hide when={props.isBrokeredSale}>
        <PriceBox
          data-testid={suffixTestId(`profit`, props)}
          colored
          align="left"
          percentTag={props.businessCaseLogic.totalMarginPercentage}
          price={props.saleVehicle?.profit?.withVat}
          priceSub={props.saleVehicle?.profit?.withoutVat}
          isVatDeductible={props.businessCaseLogic.isTotalVatDeductible}
          title={i18n.t`page.businessCase.labels.profit`}
        />
      </Hide>
    </Grid>
  );
}
